import axios from 'axios';

const getList = params => axios.get('requisicoes/aprovacoes', { params });

const get = id => axios.get(`requisicoes/aprovacoes/${id}`);

const getProduto = (id, idProduto) => axios.get(`requisicoes/aprovacoes/${id}/produtos/${idProduto}`);

export default {
  get,
  getProduto,
  getList,
};
